import { render, staticRenderFns } from "./ActionMenu.vue?vue&type=template&id=45f1b8a9&scoped=true"
import script from "./ActionMenu.vue?vue&type=script&lang=js"
export * from "./ActionMenu.vue?vue&type=script&lang=js"
import style0 from "./ActionMenu.vue?vue&type=style&index=0&id=45f1b8a9&prod&scoped=true&lang=pcss"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f1b8a9",
  null
  
)

export default component.exports